import { BrandWordmark } from '../../components/Logo';

/** Static fuelcyclepro mark for the dashboard content well. No spinner or fade. */
export function DashboardBootPlate() {
  return (
    <div
      data-testid="dashboard-boot-plate"
      className="flex min-h-[60vh] items-center justify-center bg-[var(--bg-primary)]"
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <BrandWordmark size={48} />
    </div>
  );
}
